import { LoadingOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

export const StepLoading: React.FC = () => {
  return (
    <Flex align="center" justify="center">
      <LoadingOutlined />
    </Flex>
  )
}
